module.exports = __webpack_public_path__ + "img/logo_colored.5a1068d5.svg";